import Loading from "componentsv2/widgets/Loading";

import StackedBar from "components/Chart/StackedBarChart";
import CardInfo from "../CardInfo";
import CardHead from "./CardHead";
import CardList from "./CardList";
import { layout } from "./ctxCharts";

function prepareData(info) {
  const items = [];
  const datasets = [];
  for (const value of layout) {
    datasets.push({
      label: value.name,
      data: [info[value.id].rate],
      backgroundColor: value.colorChart,
    });
    const item = { ...value, ...info[value.id] };
    items.push(item);
  }
  return [items, datasets];
}

function CardIndicator({ title, nameId, data, isPending }) {
  if (!data) {
    return <Loading />;
  }

  const info = data[nameId];
  const [items, datasets] = prepareData(info);

  const dataChart = {
    labels: ["Rooms"],
    datasets: datasets,
  };

  return (
    <CardInfo title={title} key={nameId}>
      <CardHead title="Total Rooms" value={data.total_rooms} />
      <StackedBar refName={nameId} data={dataChart} />
      {items.map((item, index) => (
        <CardList key={index} item={item} />
      ))}
    </CardInfo>
  );
}

export default CardIndicator;
